// pages/Help/HelpNotice.jsx
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import HelpAside from "../components/HelpAside";
import axios from "axios";
import { FiSearch } from "react-icons/fi";
import wizMarket from  "../../../assets/image/home/wizMarketLogo.png"

const formatDate = (dateString) => {
    const d = new Date(dateString);
    if (isNaN(d)) return "";
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${dd}`;
};

const HelpNotice = () => {
    const navigate = useNavigate();

    const [notices, setNotices] = useState(null);
    const [err, setErr] = useState("");

    const [q, setQ] = useState("");
    const [page, setPage] = useState(1);
    const PAGE_SIZE = 10;

    useEffect(() => {
        const fetchNotices = async () => {
            setErr("");
            try {
                const { data } = await axios.get(
                    `${process.env.REACT_APP_FASTAPI_ADS_URL}/ads/get/notice`
                );
                setNotices(Array.isArray(data) ? data : []);
            } catch (e) {
                console.error(e);
                setErr("공지사항을 불러오지 못했습니다.");
                setNotices([]);
            }
        };
        fetchNotices();
    }, []);

    const filtered = useMemo(() => {
        const base = Array.isArray(notices) ? notices : [];
        const keyword = q.trim().toLowerCase();
        if (!keyword) return base;
        return base.filter((n) =>
            (n.notice_title || "").toLowerCase().includes(keyword)
        );
    }, [q, notices]);

    const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
    const paged = useMemo(() => {
        const start = (page - 1) * PAGE_SIZE;
        return filtered.slice(start, start + PAGE_SIZE);
    }, [filtered, page]);

    const openDetail = (n) => {
        navigate(`/help/notice/${n.notice_no}`, { state: { notice: n } });
    };

    return (
        <div className="min-h-screen bg-white">
            <header className="max-w-6xl mx-auto top-0 z-50">
                <div className="h-15 px-5 py-3 flex items-center justify-between">
                    <a href="/" className="flex items-center gap-2 pl-6">
                        <img src={wizMarket} alt="wizMarket" className="h-8 w-auto" />
                        <p style={{fontFamily: "SonsieOne"}}>wiz Market</p>
                    </a>
                    <div className="flex items-center gap-2">
                        <a href="/help"className="px-8 py-2 inline-flex items-center rounded-md bg-black/10 text-lg hover:bg-black/30">
                            고객센터
                        </a>
                        {/* <div className="px-4 py-2 inline-flex items-center text-white rounded-md bg-[#7864F9]/60 text-lg font-medium hover:bg-[#7864F9]">
                            로그인/회원가입
                        </div> */}
                    </div>
                </div>
            </header>
            <div className="max-w-6xl mx-auto px-6 grid grid-cols-12 gap-8 pt-8">
                {/* 좌측 사이드 */}
                <HelpAside activeKey="notice" />

                {/* 메인 */}
                <main className="col-span-12 lg:col-span-9">
                    <div className="flex justify-between items-center">
                        <h1 className="text-2xl font-extrabold tracking-tight">공지사항</h1>
                        <div className="relative">
                            <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                            <input
                                type="text"
                                value={q}
                                onChange={(e) => {
                                    setPage(1);
                                    setQ(e.target.value);
                                }}
                                placeholder="검색어를 입력해주세요"
                                className="border rounded-md pl-10 pr-4 py-2 text-sm"
                            />
                        </div>
                    </div>

                    {err && (
                        <div className="mt-3 rounded-lg bg-red-50 text-red-700 px-3 py-2 text-sm">
                            {err}
                        </div>
                    )}

                    <p className="text-gray-500 pt-2 pb-6">
                        총 <span className="font-semibold">{filtered.length}</span> 건
                    </p>

                    {/* 리스트 테이블 */}
                    <div className="rounded-2xl border overflow-hidden">
                        {/* 헤더 */}
                        <div className="grid grid-cols-12 text-center bg-gray-50 text-gray-500 text-sm font-medium px-3 py-3">
                            <div className="col-span-1">번호</div>
                            <div className="col-span-9">제목</div>
                            <div className="col-span-2 pr-2">등록일</div>
                        </div>

                        {/* 바디 */}
                        <div className="divide-y">
                            {Array.isArray(notices) && paged.length === 0 ? (
                                <div className="px-3 py-10 text-center text-gray-400">
                                    표시할 공지사항이 없습니다.
                                </div>
                            ) : (
                                paged.map((row, idx) => {
                                    const index = (page - 1) * PAGE_SIZE + idx + 1;
                                    return (
                                        <button
                                            key={row.notice_no}
                                            onClick={() => openDetail(row)}
                                            className="w-full text-left grid grid-cols-12 items-center px-3 py-4 hover:bg-gray-50 transition-colors"
                                        >
                                            <div className="col-span-1 text-gray-500 text-center">
                                                {index}
                                            </div>
                                            <div className="col-span-9 flex items-center pl-4">
                                                <span className="text-gray-800 truncate">
                                                    {row.notice_title}
                                                </span>
                                            </div>
                                            <div className="col-span-2 text-center pr-2 text-gray-600">
                                                {formatDate(row.created_at)}
                                            </div>
                                        </button>
                                    );
                                })
                            )}
                        </div>
                    </div>

                    {/* 페이지네이션 */}
                    {Array.isArray(notices) && totalPages > 1 && (
                        <div className="flex justify-center gap-4 mt-6">
                            {Array.from({ length: totalPages }, (_, i) => i + 1).map((num) => (
                                <button
                                    key={num}
                                    onClick={() => setPage(num)}
                                    className={`w-8 h-8 rounded-full ${
                                        num === page
                                            ? "bg-violet-500 text-white"
                                            : "text-gray-700 hover:bg-gray-100"
                                    }`}
                                >
                                    {num}
                                </button>
                            ))}
                        </div>
                    )}
                </main>
            </div>
        </div>
    );
};

export default HelpNotice;
